import React from 'react';
import './Item.css';

const Item = (props) => {
    return (
        <div className='item-card' onClick={props.onClick}> {/* Attach onClick here */}
            <img 
                src={props.image} 
                alt={props.name} 
                className='item-image'
            />
            <div className='item-info'>
                <p className='item-name'>{props.name}</p>
                <div className="item-prices">
                    <div className="item-price-new">
                        ${props.new_price}
                    </div>
                    {/* Conditionally render old price if it's different from new price */}
                    {props.new_price !== props.old_price && (
                        <div className="item-price-old">
                            ${props.old_price}
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
}

export default Item;
